import styles from "./ProviderForm.module.css";

import React, { useState, useEffect } from "react";
import { Grid, TextField, Button } from "@material-ui/core";
import {
  areAllPropertiesEmpty,
  hasLength,
  isNumeric,
} from "../../../utils/Validator.js";

const INITIAL_ERROR_STATE = {
  ftin: "",
  providerName: "",
};

const MAX_PROVIDERS = 1;

// Lets you add or update provider information
function ProviderForm({
  onAddProvider,
  onUpdateProvider,
  initialProvider = null,
  onCancel,
  providers = [],
}) {
  const [provider, setProvider] = useState({
    ftin: initialProvider?.ftin || "",
    providerName: initialProvider?.providerName || "",
  });

  const [errors, setErrors] = useState({ ftin: "", providerName: "" });

  // Re-add the useEffect to handle changes to initialProvider when editing
  useEffect(() => {
    if (initialProvider) {
      setProvider({
        ftin: initialProvider.ftin || "",
        providerName: initialProvider.providerName || "",
      });
    }
  }, [initialProvider]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const fieldMap = {
      providerFtin: "ftin",
      providerName: "providerName",
    };

    setProvider({
      ...provider,
      [fieldMap[name]]: value,
    });
  };

  const validateForm = () => {
    const newErrors = { ...INITIAL_ERROR_STATE };

    if (!hasLength(provider.ftin, 9) || !isNumeric(provider.ftin)) {
      newErrors.ftin = "Enter 9 digit FTIN.";
    }

    if (!hasLength(provider.providerName, 2)) {
      newErrors.providerName = "Provider name is required.";
    }

    setErrors(newErrors);

    return areAllPropertiesEmpty(newErrors);
  };

  const handleSubmit = () => {
    if (validateForm()) {
      if (initialProvider) {
        onUpdateProvider(provider);
      } else {
        onAddProvider(provider);
      }

      setProvider({ ftin: "", providerName: "" });
    }
  };

  const handleCancel = () => {
    setProvider({ ftin: "", providerName: "" });
    onCancel();
  };

  return (
    <div className={styles.providerForm}>
      <Grid container spacing={3} alignItems="top" wrap="wrap">
        <Grid item xs={4}>
          <TextField
            id="providerFtin"
            name="providerFtin"
            label="Provider FTIN"
            error={!!errors.ftin}
            helperText={errors.ftin}
            value={provider.ftin}
            onChange={handleInputChange}
            inputProps={{ maxLength: 9 }}
            fullWidth
          />
        </Grid>

        <Grid item xs>
          <TextField
            id="providerName"
            name="providerName"
            label="Provider Name"
            error={!!errors.providerName}
            helperText={errors.providerName}
            value={provider.providerName}
            onChange={handleInputChange}
            inputProps={{ maxLength: 128 }}
            fullWidth
          />
        </Grid>

        <Grid item style={{ alignSelf: "top", marginTop: "16px" }}>
          {initialProvider ? (
            <Button onClick={handleSubmit} type="button">
              OK
            </Button>
          ) : (
            <Button
              onClick={handleSubmit}
              type="button"
              disabled={providers.length >= MAX_PROVIDERS}
            >
              Add
            </Button>
          )}

          {initialProvider && (
            <Button onClick={handleCancel} type="button">
              Cancel
            </Button>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export { ProviderForm };
